/* eslint-disable react/jsx-props-no-spreading */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Link } from 'react-router-dom';
import { push as pushAction } from 'react-router-redux';
import { Table } from '@devexpress/dx-react-grid-bootstrap3';
import {
	isEqual, isEmpty, omit, indexOf, get, pick,
} from 'lodash';
import classNames from 'classnames';
import JobActions from '@redux/jobs';
import { CellFormatters } from '@components';

/**
 * Hence this component has a rather
 * complicated state, we did this
 * function to build the state structure
 * so we don't need to repeat so much
 * code
 */
const buildStateStructure = (props) => {
	const {
		onToggle,
		row,
		column = {},
		tableRow : { rowId },
		stateProps : {
			query,
			timeZone,
			expandedRowIds,
			viewType,
		},
	} = props;
	const columnName = get(column, 'name');
	const targetProps = { row };
	let cellProps = {};

	switch (columnName) {
		case 'job': {
			targetProps.query = query;
			targetProps.timeZone = timeZone;
			targetProps.jobType = row.StatusId;
			targetProps.cellClassName = 'padding-left-15';
			targetProps.linkComponent = Link;
			break;
		}

		case 'location': {
			break;
		}

		case 'status': {
			targetProps.viewType = viewType;
			break;
		}

		case 'date': {
			targetProps.timeZone = timeZone;
			targetProps.jobType = row.StatusId;
			break;
		}

		case 'actions': {
			targetProps.expanded = indexOf(expandedRowIds, rowId) !== -1;
			break;
		}

		default: {
			break;
		}
	}

	if (onToggle) {
		cellProps = {
			className : classNames('stripe', {
				red    : row.ApplicantsAssigned < 1,
				orange : row.ApplicantsAssigned > 0 && row.ApplicantsAssigned < row.ApplicantsNeeded,
				green  : row.ApplicantsAssigned >= row.ApplicantsNeeded,
			}),
		};
	}

	return {
		columnName,
		targetProps,
		cellProps,
	};
};

export const NativeCell = (props) => (<td {...props} />);

export class CellComponent extends Component {
	constructor(props) {
		super(props);

		this.state = { ...buildStateStructure(props) };
	}

	static getDerivedStateFromProps(nextProps, lastState) {
		const newState = {};
		const {
			columnName,
			targetProps,
			cellProps,
		} = buildStateStructure(nextProps);

		if (!isEqual(columnName, lastState.columnName)) newState.columnName = columnName;

		if (!isEqual(targetProps, lastState.targetProps)) newState.targetProps = targetProps;

		if (!isEqual(cellProps, lastState.cellProps)) newState.cellProps = cellProps;

		return !isEmpty(newState) ? newState : null;
	}

	shouldComponentUpdate = (props, { columnName, targetProps, cellProps }) => {
		const lastState = this.state;

		return (
			!isEqual(columnName, lastState.columnName)
			|| !isEqual(targetProps, lastState.targetProps)
			|| !isEqual(cellProps, lastState.cellProps)
		);
	}

	defaultFormatter = () => (null);

	onToggleDetailsRow = () => {
		const {
			actionProps : { toggleDetailsExpansion },
			tableRow : { rowId },
		} = this.props;

		toggleDetailsExpansion(rowId);
	}

	onClickDetails = () => {
		const {
			actionProps : { push },
			row : { Id },
		} = this.props;

		push(`/jobs/${Id}`);
	}

	onClickMap = () => {
		const {
			actionProps : { push },
			stateProps : { viewType },
			row : { Id },
		} = this.props;

		push(`/jobs/map/${viewType}/${Id}`);
	}

	render() {
		const {
			columnName,
			targetProps : stateTargetProps,
			cellProps : stateCellProps,
		} = this.state;
		const targetProps = {};
		let cellProps = { ...omit(this.props, ['stateProps', 'actionProps']) };
		let Formatter;
		let { Cell } = Table;

		switch (columnName) {
			case 'job': {
				Formatter = CellFormatters.JobFormatter;
				break;
			}

			case 'location': {
				Formatter = CellFormatters.LocationFormatter;
				break;
			}

			case 'status': {
				Formatter = CellFormatters.StatusFormatter;
				break;
			}

			case 'date': {
				Formatter = CellFormatters.DateFormatter;
				break;
			}

			case 'actions': {
				Formatter = CellFormatters.ActionsFormatter;
				targetProps.onToggleDetailsRow = this.onToggleDetailsRow;
				targetProps.onClickDetails = this.onClickDetails;
				targetProps.onClickMap = this.onClickMap;
				break;
			}

			default: {
				Formatter = this.defaultFormatter;
				break;
			}
		}

		if (cellProps.onToggle) {
			Cell = NativeCell;
			Formatter = this.defaultFormatter;
			cellProps = stateCellProps;
		}

		return (
			<Cell {...cellProps}>
				<Formatter {...targetProps} {...stateTargetProps} />
			</Cell>
		);
	}
}

const mapStateToProps = ({
	router : {
		location : { query },
		match : { params : { viewType } },
	},
	app : { user : { TimeZoneId : timeZone } },
	jobs : {
		expandedRowIds,
	},
}) => ({
	stateProps : {
		query,
		timeZone,
		expandedRowIds,
		viewType,
	},
});

const mapDispatchToProps = (dispatch) => ({
	actionProps : {
		push : bindActionCreators(pushAction, dispatch),
		...pick(bindActionCreators(JobActions, dispatch), ['toggleDetailsExpansion']),
	},
});

CellComponent.propTypes = {
	actionProps : PropTypes.object.isRequired,
	stateProps  : PropTypes.object.isRequired,
	row         : PropTypes.object.isRequired,
	tableRow    : PropTypes.object.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(CellComponent);
